import React from "react";
import Header from "../../components/Header";
import ModalLogShow from "./ModalLogShow";
import PageArticle from "./PageArticle";
import Provider from "./Provider";
import { PageLogUpdatedPriceFC } from "./types";

const PageLogUpdatedPrice: PageLogUpdatedPriceFC = () => {
  return (
    <Provider>
      <Header title={"Лог обновления цен"} />
      <PageArticle />
      <ModalLogShow />
    </Provider>
  );
};

export default PageLogUpdatedPrice;
